var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.706 6.13V3H1l.092 13.287.135 13.33 11.764.135 11.716.09v-3.13H4.647V6.13h20.06zm5.699 5.684c-.5-1.567-2.051-2.953-3.83-3.446-4.422-1.207-8.25.85-8.25 4.34 0 2.952 1.55 4.25 5.79 4.83 2.597.315 3.463.986 3.236 2.507-.274 1.969-4.101 2.237-5.743.402-.775-.94-3.74-1.252-3.74-.447 0 1.253 1.597 3.266 2.965 3.847 2.005.805 5.29.805 7.294 0 2.962-1.208 3.875-5.637 1.595-7.65-.5-.447-2.37-1.118-4.147-1.52-3.556-.806-4.65-1.701-3.647-2.91.91-1.073 4.012-.939 4.696.18.41.626 1.092.895 2.324.895 1.596 0 1.732-.089 1.459-1.028z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkl);
export default __webpack_public_path__ + "static/media/SKL.a067587b128955e097d8969287a5cc46.svg";
export { ForwardRef as ReactComponent };